import { CUSTOM_REPORT_ACTION_TYPE } from './custom-report-type';

export type CustomReportState = {
    loading: boolean;
    error: boolean;
};

const initialState: CustomReportState = {
    loading: false,
    error: false,
};

type CustomReportAction =
    | { type: CUSTOM_REPORT_ACTION_TYPE.SET_CUSTOM_REPORT_STATE; payload: Partial<CustomReportState> }
    | { type: CUSTOM_REPORT_ACTION_TYPE.CALL_POST_CUSTOM_REPORT }
    | { type: CUSTOM_REPORT_ACTION_TYPE.CALL_GET_CUSTOM_REPORTS }
    | { type: CUSTOM_REPORT_ACTION_TYPE.CALL_DOWNLOAD_CUSTOM_REPORT };

export const customReportReducers = (
    state: CustomReportState = initialState,
    action: CustomReportAction,
): CustomReportState => {
    switch (action.type) {
        case CUSTOM_REPORT_ACTION_TYPE.SET_CUSTOM_REPORT_STATE:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};
